import { z } from "zod";
import {
	prepareZebraMachineData,
	type ZebraMachine,
	type ZebraMachineRequest,
	zebraMachineSchema,
} from "@packsize/schemas/machines";

import { packNetAxios } from "@/lib/api-client";

import { baseRoutes } from "../base-routes";

export async function getZebraMachines(): Promise<ZebraMachine[]> {
	const response = await packNetAxios.get(`${baseRoutes.zebra}/api/v1/Machines`);

	if (Array.isArray(response.data) === false) {
		throw new Error("Unable to fetch Zebra machines, response is not a list");
	}

	return z
		.array(zebraMachineSchema)
		.enrich({ callSite: "getZebraMachines - v2" })
		.parseWithTelemetry(response.data.map(prepareZebraMachineData));
}

export async function getZebraMachine(machineId: string): Promise<ZebraMachine | null> {
	const response = await packNetAxios.get(`${baseRoutes.zebra}/api/v1/Machines/${machineId}`);

	if (response.status !== 200) {
		return null;
	}

	return zebraMachineSchema
		.enrich({ callSite: "getZebraMachine - v2" })
		.parseWithTelemetry(prepareZebraMachineData(response.data));
}

export async function createZebraMachine(data: ZebraMachineRequest): Promise<void> {
	await packNetAxios.post(`${baseRoutes.zebra}/api/v1/Machines`, data);
}

export async function updateZebraMachine(
	tenantId: string,
	machineId: string,
	data: ZebraMachineRequest,
): Promise<void> {
	// TODO @eb: Remove machineId and tenantId from the payload when the backend no longer requires it.
	await packNetAxios.put(`${baseRoutes.zebra}/api/v1/Machines/${machineId}`, {
		id: machineId,
		tenantId,
		...data,
	});
}
